"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function transform(css) {
    const rules = css
        .split(/\s/m)
        .map((x) => x.trim())
        .filter(Boolean);
    return rules.join(' ');
}
function cls(object) {
    return Object.freeze(Object.entries(object).reduce((acc, [key, css]) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        acc[key] = transform(css);
        return acc;
    }, {}));
}
exports.default = cls;
//# sourceMappingURL=tailwind.js.map